<header class="page-heading"><h1 tabindex="0" autofocus>{{ heading }}</h1><h2 class="larger-font subheading" v-if="subheading">{{ subheading }}</h2></header>